<template>
    <Transition v-if="isLoading"
                name="spinner">
        <div id="cover-spin">
            <span class="loader">
                <span>{{ $spinnerText }}</span>
            </span>
        </div>
    </Transition>

    <v-form :name="props.formProps.formName">
        <Tabs value="0"
              scrollable>

            <TabList class="mb-4">
                <Tab value="0">{{ __('Basic data') }}</Tab>
                <Tab value="1">{{ __('Changelog') }}</Tab>
            </TabList>

            <TabPanels>
                <TabPanel value="0">
                    <div class="grid">
                        <FormCalendar fieldName="operation_date"
                                      label="Operation date"
                                      size="2"
                                      :isFormDisabled="true"
                                      v-model:field="crud.operation_date" />

                        <FormInputNumber fieldName="statement_amount"
                                         label="Statement amount"
                                         size="3"
                                         :isFormDisabled="true"
                                         v-model:field="crud.statement_amount" />
                        <FormInputText fieldName="transfer_title"
                                       label="Transfer title"
                                       size="7"
                                       :isFormDisabled="true"
                                       v-model:field="crud.transfer_title" />
                    </div>
                    <div class="grid">
                        <FormInputText fieldName="company_bank_account"
                                       label="Company bank account"
                                       size="3"
                                       :isFormDisabled="true"
                                       v-model:field="crud.company_bank_account" />
                        <FormInputText fieldName="contractor_bank_account"
                                       label="Contractor bank account"
                                       size="3"
                                       :isFormDisabled="true"
                                       v-model:field="crud.contractor_bank_account" />
                        <FormInputText fieldName="contractor_name"
                                       label="Contractor name"
                                       size="6"
                                       :isFormDisabled="true"
                                       v-model:field="crud.contractor_name" />
                    </div>
                    <div class="grid">
                        <FormSelect fieldName="project_id"
                                    label="Project"
                                    size="5"
                                    :isFormDisabled="true"
                                    :options="select?.projects"
                                    v-model:field="crud.project_id" />
                        <FormSelect fieldName="contractor_id"
                                    label="Contractor"
                                    size="4"
                                    :isFormDisabled="true"
                                    :options="select?.contractors"
                                    v-model:field="crud.contractor_id" />
                        <FormInputNumber fieldName="assigned_amount"
                                         label="Assigned amount"
                                         size="3"
                                         :isFormDisabled="isFormDisabled"
                                         v-model:field="crud.assigned_amount" />
                    </div>
                </TabPanel>

                <TabPanel v-if="crud.log"
                          value="1"
                          :pt="{ root: { class: 'form-tab-panel' } }">
                    <ChangeLog :log="crud?.log" />
                </TabPanel>
            </TabPanels>
        </Tabs>

        <div class="grid">
            <FormButtons :formProps="props.formProps"
                         :sourceForm="crud"
                         :validation="validation"
                         :buttonsVisibility="buttonsVisibility"
                         v-model:isFormDisabled="isFormDisabled">
                <template #after-in-edit>
                    <AlertAddButton :addAlert="addAlert" />
                </template>
            </FormButtons>
        </div>
        <AlertAdd :formProps="{ source_table: 'project_statements', source_id: crud.id, width: '50%' }"
                  v-model:isAddAlertDialogOpen="isAddAlertDialogOpen" />
    </v-form>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import Tabs from 'primevue/tabs';
import TabList from 'primevue/tablist';
import Tab from 'primevue/tab';
import TabPanels from 'primevue/tabpanels';
import TabPanel from 'primevue/tabpanel';

import FormInputText from '@crud/FormInputText.vue'
import FormInputNumber from '@crud/FormInputNumber.vue'
import FormSelect from '@crud/FormSelect.vue'
import FormCalendar from '@crud/FormCalendar.vue'
import FormButtons from '@crud/FormButtons.vue'
import ChangeLog from '@crud/ChangeLog.vue'
import AlertAdd from '@app/Data/Alert/AlertAdd.vue'
import AlertAddButton from '@alert/AlertAddButton.vue'
import { validation, initFormObj } from '@pages/Helper/crud_utils.js'
import { __ } from '@helper/utils.js'

// -----------------------------------------------------

const props = defineProps({
    formProps: Object,
})

const isLoading = ref(true);
const isFormDisabled = ref(true)
const crud = ref({})
const options = ["statements", "projects", "contractors"];
const select = ref(null);

const isAddAlertDialogOpen = ref(false);
const buttonsVisibility = ref({})

// -----------------------------------------------------

onMounted(async () => {
    await initFormObj({ props, crud, isLoading, buttonsVisibility, options, select })
})

// -----------------------------------------------------

const addAlert = async () => {
    isAddAlertDialogOpen.value = true;
}

// -----------------------------------------------------

</script>

<style lang="scss" scoped></style>
